<mat-form-field>
    <mat-label>{{ model.additional!['LABEL'] }}</mat-label>
    <textarea matInput [value]="value" [readonly]="model.readOnly" autocomplete="off" (keyup)="onInputChanged($event)"></textarea>
</mat-form-field>